import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useLogger } from "utils/logger";

export function useRuleEngine({ userAccountData }) {
  const router = useRouter();

  const [userIDVRequired, setUserIDVRequired] = useState(null);
  const [ruleEngineCompleted, setRuleEngineCompleted] = useState(null);
  const [ruleEngineInprogress, setRuleEngineInprogress] = useState(null);
  const [callRuleEngine, setCallRuleEngine] = useState(null);

  const { log, error, warn } = useLogger();

  useEffect(() => {
    if (ruleEngineCompleted || ruleEngineInprogress) return;
    if (!callRuleEngine) return;

    log("Rule Engine started");
    setRuleEngineInprogress(true);

    async function onboardingRuleEngineCheck() {
      try {
        const response = await fetch("/api/onboarding/rule-engine", {
          method: "POST",
          body: JSON.stringify({ userAccountData }),
        });
        const ruleEngineResponse = await response.json();
        if (response.ok) {
          log(`Rule Engine Response ${JSON.stringify(ruleEngineResponse)}`);

          setRuleEngineCompleted(true); // we are invoking onfido based on this state
          setUserIDVRequired(ruleEngineResponse.IDV_FLAG); // IDV Flag result
        } else {
          warn(
            `Rule Engine API Failed : ${JSON.stringify(ruleEngineResponse)}`,
          );
          router.push("/500"); // ONBOARDING RULE-ENGINE WITH 400 STATUS
        }
      } catch (err) {
        error(`Rule Engine Error: ${JSON.stringify(err)}`);
        router.push("/500"); // ONBOARDING RULE-ENGINE TRY FAILED
      }
    }
    onboardingRuleEngineCheck();
  }, [
    userAccountData,
    error,
    log,
    router,
    ruleEngineCompleted,
    ruleEngineInprogress,
    warn,
  ]);

  return {
    userIDVRequired,
    ruleEngineCompleted,
    setCallRuleEngine,
    callRuleEngine,
  };
}
